import { IAccount, IAuth } from '@/service/login/loginType'
import lfRequest from '@/service/index'

enum LoginApi {
  AccountLogin = '/admin/login'
}

export function accountLoginRequest(account: IAccount) {
  return lfRequest.post<IAuth>({
    url: LoginApi.AccountLogin,
    data: account
  })
}
